module.exports = __webpack_public_path__ + "img/112.160a1f69.jpg";